export const MASTER_PATH = {
  ITEM: '/master/item',
  SHIP: '/master/ship',
  MAIL: '/master/mail',
};
